import { run, showPreferences } from "vanilla-cookieconsent";

/** Bandeau cookies (vanilla-cookieconsent), textes FR alignés sur la politique wownautic.com. */
const POLICY_BASE = "https://wownautic.com";

const fr = {
  consentModal: {
    title: "Nous utilisons des cookies",
    description:
      'Nous utilisons des cookies pour améliorer votre expérience de navigation, proposer du contenu personnalisé et analyser notre trafic. En cliquant sur "Tout accepter", vous consentez à notre utilisation des cookies.',
    acceptAllBtn: "Tout accepter",
    acceptNecessaryBtn: "Tout refuser",
    showPreferencesBtn: "Gérer les préférences",
    footer: `<a href="${POLICY_BASE}/privacy-policy">Politique de Confidentialité</a>\n<a href="${POLICY_BASE}/cookie-policy">Politique des Cookies</a>`,
  },
  preferencesModal: {
    title: "Préférences des Cookies",
    acceptAllBtn: "Tout accepter",
    acceptNecessaryBtn: "Tout refuser",
    savePreferencesBtn: "Enregistrer les préférences",
    closeIconLabel: "Fermer",
    serviceCounterLabel: "Service|Services",
    sections: [
      {
        title: "Utilisation des Cookies",
        description:
          "Nous utilisons des cookies pour garantir les fonctionnalités de base du site Web et améliorer votre expérience en ligne. Vous pouvez choisir pour chaque catégorie d'activer/désactiver quand vous le souhaitez.",
      },
      {
        title:
          'Cookies Strictement Nécessaires <span class="pm__badge">Toujours Activés</span>',
        description:
          "Ces cookies sont essentiels au bon fonctionnement du site Web. Sans ces cookies, le site Web ne fonctionnerait pas correctement.",
        linkedCategory: "necessary",
      },
      {
        title: "Cookies d'Analyse",
        description:
          "Ces cookies collectent des informations sur la façon dont vous utilisez le site Web, les pages que vous avez visitées et les liens sur lesquels vous avez cliqué. Toutes les données sont anonymisées et ne peuvent pas être utilisées pour vous identifier.",
        linkedCategory: "analytics",
        cookieTable: {
          headers: {
            name: "Nom",
            domain: "Domaine",
            description: "Description",
            expiration: "Expiration",
          },
          body: [
            {
              name: "_ga",
              domain: "wownautic.com",
              description: "Cookie Google Analytics",
              expiration: "2 ans",
            },
            {
              name: "_gid",
              domain: "wownautic.com",
              description: "Cookie Google Analytics",
              expiration: "1 jour",
            },
          ],
        },
      },
      {
        title: "Cookies Marketing",
        description:
          "Ces cookies sont utilisés pour suivre les visiteurs sur les sites Web. L'intention est d'afficher des publicités pertinentes et engageantes pour l'utilisateur individuel.",
        linkedCategory: "marketing",
      },
      {
        title: "Plus d'informations",
        description: `Pour toute question concernant notre politique en matière de cookies et vos choix, veuillez <a class="cc__link" href="${POLICY_BASE}/">nous contacter</a>.`,
      },
    ],
  },
};

let initPromise = null;

export function initCookieConsent() {
  if (initPromise) return initPromise;
  initPromise = run({
    mode: "opt-in",
    autoShow: false,
    lazyHtmlGeneration: true,
    guiOptions: {
      consentModal: {
        layout: "box inline",
        position: "bottom left",
        equalWeightButtons: true,
        flipButtons: false,
      },
      preferencesModal: {
        layout: "box",
        position: "right",
        equalWeightButtons: true,
        flipButtons: false,
      },
    },
    categories: {
      necessary: {
        readOnly: true,
        enabled: true,
      },
      analytics: {
        enabled: false,
        autoClear: {
          cookies: [{ name: /^_ga/ }, { name: "_gid" }],
        },
      },
      marketing: {
        enabled: false,
      },
    },
    language: {
      default: "fr",
      translations: {
        fr,
      },
    },
  }).catch((err) => {
    initPromise = null;
    throw err;
  });
  return initPromise;
}

export { showPreferences };
